export default __webpack_public_path__ + "static/media/carouselTwo.d74be918.png";